import { Component } from '@angular/core';

@Component({
  templateUrl: './pricing.component.html',
})
export class PricingComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/pricing.component.ts